module.exports = __webpack_public_path__ + "img/button-save.f0bad7f7.svg";